import * as THREE from "three";

export class RenderContext{
	/**
	 * @param scene
	 * [THREE.Scene](https://threejs.org/docs/#api/scenes/Scene)
	 * @param camera
	 * [THREE.PerspectiveCamera](https://threejs.org/docs/#api/cameras/PerspectiveCamera)
	 * @param anchor
	 * [THREE.Object3D](https://threejs.org/docs/#api/core/Object3D)
	 */
	constructor(
		public scene: THREE.Scene,
		public camera: THREE.PerspectiveCamera,
		public anchor: THREE.Object3D
	){

	}
}


// WEBPACK FOOTER //
// ./src/script/app3D/RenderContext.ts